import { defineComponent, reactive, watch } from '@vue/composition-api'
import './index.scss'
import _ from 'lodash'
const MatrixContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })

    watch(
      () => props.item,
      (val) => {
        state.editItem = _.cloneDeep(val)
      },
      {
        deep: true
      }
    )

    const elRadioGroupChange = (value, index) => {
      state.editItem.matrixValue[index].value = value
      state.editItem.isShowTitleError = false
      emit('answer', state.editItem)
    }

    const getTrueIndex = (item)=>{
      let res:boolean = false
      let resIndex:number = 0
      state.editItem.matrixValue.forEach((ele,index) => {
        if(ele.subTopicId === item.bizId){
          res = true
          resIndex = index
        }
      })
      if(res){
        return resIndex
      }else{
        return state.editItem?.matrixValue?.length
      }
    }

    return () => {
      return (
        <div class="matrix-content">
          <div class="matrix-header">
            <div class="matrix-header-item"></div>
            {props.item.topicSetting.topicOptionSetting?.map((item) => {
              return (
                <div
                  class="matrix-header-item"
                  domPropsInnerHTML={item.optionName}></div>
              )
            })}
          </div>
          {(props.item.matrixTopics || []).map((item, index) => {
            return (
              <div key={item.id} class="matrix-tr-item">
                <div
                  class="sub-topic-title"
                  domPropsInnerHTML={item.topicName}
                  key={item.topicId}></div>
                <el-radio-group
                  onInput={(value) => elRadioGroupChange(value, getTrueIndex(item))}
                  value={props.item.matrixValue[getTrueIndex(item)]?.value ?? null}
                  style={{
                    flex: props.item.topicSetting?.topicOptionSetting?.length
                  }}>
                  {props.item.topicSetting?.topicOptionSetting?.map(
                    (sitem, sindex) => {
                      return (
                        <div>
                          <el-radio label={sitem.optionId}></el-radio>
                        </div>
                      )
                    }
                  )}
                </el-radio-group>
              </div>
            )
          })}
        </div>
      )
    }
  }
})
export default MatrixContent
